export default __webpack_public_path__ + "static/media/icon-info-futterverbrauch.1bcbd121.svg";